<div class="ssc ssc-card" *ngIf="!noData">
  <div class="ssc-wrapper">
    <div *ngFor="let item of placeholderArray">
      <div class="flex align-center justify-between">
        <div class="ssc-circle"></div>
        <div class="w-10">
          <div class="ssc-line w-100"></div>
          <div class="ssc-line w-100"></div>
        </div>
        <div class="w-10">
          <div class="ssc-line w-100"></div>
        </div>
        <div class="w-10">
          <div class="ssc-line w-100"></div>
          <div class="ssc-line w-100"></div>
        </div>
        <div class="w-10">
          <div class="ssc-line w-100"></div>
        </div>
        <div class="w-10">
          <div class="ssc-line w-100"></div>
        </div>
      </div>
      <div class="ssc-hr"></div>
    </div>
  </div>
</div>
<div *ngIf="noData" class="center-image">
  <img
    src="https://storage.googleapis.com/starckorepublicbucket/searchNotFound.png"
    alt=""
  />
</div>
